/* tslint:disable:max-line-length */
/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

export const MtaIcon = (props) => {
    return (
        <svg width="33" height="20" viewBox="0 0 33 20" xmlns="http://www.w3.org/2000/svg">
            <g transform="translate(3)" fill="#CFD8DD" fillRule="evenodd">
                <circle cx="1.5" cy="11.5" r="1.5" />
                <circle cx="1.5" cy="16.5" r="1.5" />
                <path d="M5 5h8v3H5zM5 10h13v3H5z" />
                <circle cx="1.5" cy="6.5" r="1.5" />
                <path d="M5 15h18v3H5zM23 5V0h-3v5h-5v3h5v5h3V8h5V5h-5z" />
            </g>
        </svg>
    )
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/images/icons/Mta/Mta.tsx